export default Object.freeze({
  INFO: '안내',
  CANCEL: '취소',
  EXCHANGE: '교환',
  RETURN: '반품',

  SELECT_ALL: '전체선택',
  PARTNER: '파트너사',
  MALL_PRODUCT_NO: '상품번호',
  PRODUCT_NAME: '상품명',
  CNT: '수량',
  CANCEL_CNT: '취소수량',
  EXCHANGE_CNT: '교환수량',
  RETURN_CNT: '반품수량',
  CANCEL_EXCHANGE_CNT: '취소수량',
  RETURN_EXCHANGE_CNT: '반품수량',
  ORDER_CNT: '주문수량',
  SALES_PRICE: '판매가',
  DISCOUNTED_AMOUNT: '할인적용가',
  TOTAL_PRODUCT_AMOUNT: '상품합계',
  ORDER_STATUS: '주문상태',
  HOLD_DELIVERY: '배송보류',
  CANCEL_REASON: '취소구분/사유',
  EXCHANGE_REASON: '교환구분/사유',
  RETURN_REASON: '반품구분/사유',
  RESPONSIBLE_TARGET: '귀책대상',

  ACCOUNT_REFUND: '현금환불',
  ACCUMULATION_REFUND: '적립금 복원',
  ZERO_REFUND_REFUND: '0원환불',

  SET: '세트',
  SET_COMPOSITION: '세트구성',
  BUYER: '구매자',
  SELLER: '판매자',
  SELLER_INFO: '판매자정보',
  DEPOSITOR: '입금자',
  PHONE: '연락처',
  CELL_PHONE: '휴대폰번호',
  NORMAL_PHONE: '전화번호',
  CONSIGNMENT_DELIVERY: '위탁배송',
  RECEIVER_NAME: '수령자명',
  RETURNER_NAME: '반품자명',
  DELIVERY_ADDRESS: '배송지주소',
  DELIVERY_AMOUNT: '기본배송비',
  RETURN_DELIVERY_AMOUNT: '반품배송비',
  REMOTE_DELIVERY: '지역별추가',
  EXCHANGE_DELIVERY_AMOUNT: '교환(재발송)배송비',
  PAY_TYPE: '결제방법',
  ACCUMULATION_ALL_USED: '적립금 전액 사용',
  DEPOSIT_ACCOUNT_NO: '입금계좌번호',
  DELIVERY_MESSAGE: '배송메시지',

  CHANGE_MIND: '단순변심(색상, 사이즈 등)',
  DEFECTIVE_PRODUCT: '상품불량/파손',
  WRONG_DELIVERY: '배송누락/오배송',
  WRONG_PRODUCT_DETAIL: '상품상세 정보와 다름',
  DELAY_DELIVERY: '판매자 배송 지연',
  OUT_OF_STOCK: '상품 품절/재고 없음',
  OTHERS_SELLER: '기타(판매자 귀책)',
  OTHERS_BUYER: '기타(구매자 귀책)',
  OUT_OF_STOCK_SYSTEM: '재고부족(시스템)',
  CANCEL_BEFORE_PAY: '입금전취소',
  LATER_INPUT_ORDER: '배송지미입력취소',
  CANCEL_BY_LAPSE_OF_THE_ADDRESS_ENTER_PERIOD: '배송지입력 기간 경과 자동 취소',
  LATER_INPUT_ORDER_RECEIVER_CANCEL: '선물 거절 취소',

  INVOICE_NO: '송장번호',
  RETURN_INVOICE_NO: '반품 송장번호',
  RETURN_ADDRESS: '수거지주소',
  RETURN_MEMO: '수거시 참고사항',
  ORDER_REGISTER_TYPE: '주문구분',

  CANCEL_TITLE: '취소 관리',
  EXCHANGE_TITLE: '교환 관리',
  RETURN_TITLE: '반품 관리',
  REFUND_TITLE: '환불 관리',

  PROCESSING: '처리중',
  ZERO_REFUND: '0원 결제',
  ACCUMULATION: '적립금 복원',
  ACCOUNT: '현금환불',

  CANCEL_NO_REFUND: '취소완료[환불없음]',
  CANCEL_REQUEST: '취소신청[승인대기]',
  CANCEL_PROC_REQUEST_REFUND: '취소처리[환불보류]',
  CANCEL_PROC_WAITING_REFUND: '취소처리[환불대기]',
  CANCEL_DONE: '취소완료[환불완료]',
  RETURN_REQUEST: '반품신청[승인대기]',
  RETURN_REJECT_REQUEST: '반품신청[철회대기]',
  RETURN_PROC_BEFORE_RECEIVE: '반품처리[수거진행]',
  RETURN_PROC_REQUEST_REFUND: '반품처리[환불보류]',
  RETURN_REFUND_AMT_ADJUST_REQUESTED: '반품처리[조정요청]',
  RETURN_PROC_WAITING_REFUND: '반품처리[환불대기]',
  RETURN_NO_REFUND: '반품완료[환불없음]',
  RETURN_DONE: '반품완료[환불완료]',
  EXCHANGE_REQUEST: '교환신청[승인대기]',
  EXCHANGE_REJECT_REQUEST: '교환처리[철회대기]',
  EXCHANGE_PROC_BEFORE_RECEIVE: '교환처리[수거진행]',
  EXCHANGE_PROC_REQUEST_PAY: '교환처리[결제대기]',
  EXCHANGE_PROC_WAITING_PAY: '교환처리[입금처리대기]',
  EXCHANGE_PROC_WAITING: '교환처리[처리대기]',
  EXCHANGE_DONE_PAY_DONE: '교환완료[결제완료]',
  EXCHANGE_PROC_REQUEST_REFUND: '교환처리[환불보류]',
  EXCHANGE_PROC_WAITING_REFUND: '교환처리[환불대기]',
  EXCHANGE_DONE_REFUND_DONE: '교환완료[환불완료]',
  EXCHANGE_DONE: '교환완료[차액없음]',
  MODIFY: '변경',
  SAVE: '저장',
});
